module.exports = __webpack_public_path__ + "static/img/16052C_8_9_R_20200601_fit.afa886c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16052C_8_9_R_20200601_fit.png
// module id = RN77
// module chunks = 0